import React from 'react';

import LinkTargetBlank from '../Link/Link';

import useLoadContext from '../../hooks/useLoadContext';

import { getFullEdition } from '../../helper/ContextHelper';

export const LegacyMode = () => {
    const contexts = useLoadContext();
    const legacyMode = process.env.REACT_APP_ENVIRONMENT_LEGACY === 'true';
    
    return (
        <>
            { legacyMode &&
                <div style={{ backgroundColor: '#2cd179', padding: '7px', fontSize: '14px', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>
                    Você está navegando na {contexts && getFullEdition(contexts)}. 
                    Para acessar a edição atual <LinkTargetBlank link="https://olimpiadamirim.obmep.org.br/" >CLIQUE AQUI</LinkTargetBlank>.
                </div>
            }
        </>
    )
}

export default LegacyMode;
